import React from 'react';
import { useIntl } from 'umi';
import { Modal, ModalProps, Button } from 'tea-component';
import './index.scss';
import { ICommonActionRes } from '@/pages/intelligence/types/common';

interface IConfirmModalProps extends ModalProps {
  confirmText?: string;
  cancelText?: string;
  message?: string | React.ReactElement;
  onConfirm?: (e?: React.MouseEvent<Element, MouseEvent>) => Promise<ICommonActionRes>;
  onCancel?: (e?: React.MouseEvent<Element, MouseEvent>) => void;
  onClose?: () => void;
}

export default function ConfirmModal(props: IConfirmModalProps) {
  const { formatMessage } = useIntl();

  const {
    visible,
    message,
    caption = '',
    size = 'm',
    confirmText = formatMessage({ id: 'dbi_confirm' }),
    cancelText = formatMessage({ id: 'dbi_cancel' }),
    onConfirm,
    onCancel,
    onClose,
  } = props;

  return (
    <Modal visible={visible} size={size} caption={caption} className="dbi-confirm-modal" onClose={onClose}>
      <Modal.Body>
        <div className="dbi-confirm-modal_content">{message}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button type="primary" onClick={onConfirm}>
          {confirmText}
        </Button>
        <Button type="weak" onClick={onCancel}>
          {cancelText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
